module.exports = __webpack_public_path__ + "static/media/dropdownGreen.ac4298f9.svg";